export const ManagementTypeEnum = {
  lookupTypeId: 1232,
};
